"use strict";
/* eslint consistent-return: 0 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useUpdateLayoutEffect = function useUpdateLayoutEffect(effect, deps) {
  var isMounted = react_1.useRef(false);
  react_1.useLayoutEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);
};

exports["default"] = useUpdateLayoutEffect;